import type { Components, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Grid(_theme: Theme): Pick<Components, 'MuiGrid'> {
  return {
    MuiGrid: {
      styleOverrides: {
        // The legacy Grid (v1) container defaulted to `width: 100%`, while the new
        // Grid (v2, default in MUI v7) leaves containers at `width: auto`. That broke
        // every `<Grid container>` placed inside a flex-row parent (e.g. a
        // `<Stack direction="row">`), which used to fill the row and now collapses to
        // its content width.
        //
        // Restore the v1 behaviour ONLY for plain containers (`container` without a
        // `size`). A Grid that is both a container AND a sized item (a nested grid,
        // e.g. `<Grid container size={7}>`) must keep its `size`-derived
        // `width: calc(...)`, so it is intentionally excluded here.
        //
        // Note: the new Grid normalises `size` to an object (`{}` when unset,
        // `{ xs: 7 }` for `size={7}`), so "no size" means an empty object, not null.
        root: ({ ownerState }) => {
          const { container, size } = ownerState;
          const isSized =
            typeof size === 'object' && size !== null
              ? Object.keys(size).length > 0
              : size != null && size !== false;
          return {
            ...(container && !isSized && { width: '100%' }),
          };
        },
      },
    },
  };
}
